'use strict';

import { DOM } from '@levcharity/resources/scripts/helpers/DOM.js';

export class MyAccountNavigation {
    #nav;
    #toggle;
    #backdrop;
    #closeButton;
    #bodyClass = 'w4f-account-nav-open';
    #mobileQuery = window.matchMedia('(max-width: 1140px)');

    constructor() {
        this.#nav = DOM.el('.w4f-account-navigation');
        this.#toggle = DOM.el('.w4f-account-navigation__toggle');
        this.#backdrop = DOM.el('.w4f-account-navigation__backdrop');
        this.#closeButton = DOM.el('.w4f-account-navigation__close');

        if (!this.#nav || !this.#toggle) {
            return;
        }

        this.#bindEvents();
        this.#mobileQuery.addEventListener('change', () => this.#setOpen(false));
    }

    #bindEvents() {
        this.#toggle.addEventListener('click', () => {
            this.#setOpen(!document.body.classList.contains(this.#bodyClass));
        });

        this.#closeButton?.addEventListener('click', () => {
            this.#setOpen(false);
        });

        this.#backdrop?.addEventListener('click', () => {
            this.#setOpen(false);
        });

        this.#nav.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', () => {
                if (this.#mobileQuery.matches) {
                    this.#setOpen(false);
                }
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && document.body.classList.contains(this.#bodyClass)) {
                this.#setOpen(false);
            }
        });
    }

    #setOpen(open) {
        if (!this.#mobileQuery.matches) {
            document.body.classList.remove(this.#bodyClass);
            this.#backdrop?.setAttribute('hidden', '');
            this.#toggle.setAttribute('aria-expanded', 'false');
            return;
        }

        const isOpen = Boolean(open);

        this.#toggle.setAttribute('aria-expanded', String(isOpen));
        document.body.classList.toggle(this.#bodyClass, isOpen);

        if (isOpen) {
            this.#backdrop?.removeAttribute('hidden');
            return;
        }

        this.#backdrop?.setAttribute('hidden', '');
    }
}
